// SignIn
// import React, { useState } from 'react';
// import { useTranslation } from 'react-i18next';
// import Button from '../../components/design/buttons/Button';
// import Card from '../../components/design/cards/card';
// import Header from '../../components/header/header';
// import Footer from '../../components/footer/footer';
// import './Page.css'
// import React from 'react';
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { createAccount, loginAccount, verifyCode } from "../../services/accounts.service";
import Button from "../../components/design/buttons/Button";
import Footer from "../../components/footer/footer";
import { Modal } from "react-bootstrap";
import Header from "../../components/header/header";
import React from "react";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import "./Login.css";
import i18n from "../../../config/i18n";
const Wrapper = () => {
    const { t, i18n } = useTranslation();
    const [isRegister, setIsRegister] = useState<boolean>(false);
    const [state, setState] = useState<string>("login");
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const redirect = searchParams.get('redirect');
    // Get all query parameters except 'redirect' to preserve them
    const queryParams = new URLSearchParams(location.search);
    queryParams.delete('redirect');
    const queryString = queryParams.toString();
    const fullRedirect = redirect ? 
      (queryString ? `${redirect}?${queryString}` : redirect) : 
      (queryString ? `/?${queryString}` : '/');
   
    // background-repeat: no-repeat;
    // background-size: cover;
    // background-attachment: fixed;
    return (
        <div style={{backgroundImage: "url(./media/hero/bg2.png)", backgroundColor:"#F7F7F7",minHeight:"100vh",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundAttachment: "fixed"
        }} className="d-flex flex-column justify-content-between">
            <div className="container">
            <Header/>
            {/* {redirect} */}
            <div className="container h-100">
                {isRegister ? <SignIn to={fullRedirect}/> :
                <Login to={fullRedirect} />}
                <div className="w-100 text-center mt-3">
                    <span className="devider">
                        <span>{t("login.or")}</span>
                    </span>
                </div>
                    <div className="text-center w-100">
                        {
                            isRegister ? t("login.already_have_account") :
                        t("login.you_have_no_account")} <a style={{cursor:"pointer"}} onClick={(e) => {
                            e.preventDefault();
                            setIsRegister(!isRegister);
                        } }
                        >{isRegister ? t("login.login") :
                            t("login.register")}</a>
                    </div>
                    <div className='d-flex justify-content-center mt-4 flex-column align-items-center'>
                        <img src="/media/svgs/cst.svg" width={52}/>        
                        <span style={{textAlign:"start", fontWeight:"300", padding:"16px"}} className=" ">{t("login.tygo_cst_text")}</span>
                    </div>
                    
                </div>
            </div>
            <Footer />
        </div>
    );
};
const SignIn = ({to} : {to: string | null}) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState<boolean>(false);
    const [email, setEmail] = useState<string>("");
    const [phone, setPhone] = useState<string>("");
    const [firstName, setFirstName] = useState<string>("");
    const [lastName, setLastName] = useState<string>("");
    const [error, setError] = useState<string>("");
    const [firstNameError, setFirstNameError] = useState<string>("");
    const [lastNameError, setLastNameError] = useState<string>("");
    const [phoneError, setPhoneError] = useState<string>("");
    const [emailError, setEmailError] = useState<string>("");
    const [state, setState] = useState<string>("register");
    const [method, setMethod] = useState<string>("PhoneNumber");
    const [res, setRes] = useState<boolean>(false);
    const navigate = useNavigate();
    const validateEmail = (email: string) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    }
    const validatePhone = (phone: string) => {
        const re = /^[0-9]{10}$/;
        return re.test(phone);
    }

    const register = async () => {
        setFirstNameError("");
        setLastNameError("");
        setPhoneError("");
        setEmailError("");
        setError("");

        if(res) {
            setRes(false);
        }
        
        setRes(true);
        let a = false;
        if(firstName === "") {
            // setNameError("Name is required");
            setFirstNameError(t("store.register.firstname_error") || "");
            a = true;
        }
        if(lastName === "") {
            // setNameError("Name is required");
            setLastNameError(t("store.register.lastname_error") || "");
            a = true;
        }
        if(phone === "" && method === "PhoneNumber") {
            // setPhoneError("Phone is required");
            setPhoneError(t("store.register.phone_error_required") || "");
            a = true;
        }
        if(email === "" && method === "Email") {
            // setEmailError("Email is required");
            setEmailError(t("store.register.email_error_required") || "");
            a = true;
        }
        if(a)
            return;
        if(!validateEmail(email) && method === "Email") {
            // setEmailError("Email is invalid");
            setEmailError(t("store.register.email_error_invalid") || "");
            a = true;
        }
        if(phone.length < 9 && method === "PhoneNumber") {
            // setPhoneError("Phone is invalid");
            setPhoneError(t("store.register.phone_error_invalid") || "");
            a = true;
        } 
        if(a)
            return;
        setLoading(true);
        await createAccount({
            email,
            phoneNumber:phone.toString().replace(/^0+/, ''),
            firstName:firstName,
            lastName:lastName,
            gander:"Male",
            countryCode: "966",
            registertionType: method,
        }).then((res) => {
            console.log(res);
            const user = {
                phoneNumber: phone,
                email,
                firstName,
                lastName,
                countryCode: "966",
            }
            localStorage.setItem("tygo_user", JSON.stringify(user));

            if(res.status === 200) {
                setState("otp");
            }
            
            setLoading(false);
        }
        ).catch(async (err) => {
            setError(err.response.data.message);
            setLoading(true);
            if(err.response.data.message === "Email already exist" || err.response.data.message === "Phone number already exist") {
            
            await loginAccount({
                email,
                phoneNumber:phone.toString().replace(/^0+/, ''),
                countryCode: "966",
                logintType: method,
            })
            .then((res) => {
                console.log(res);
                const user = {
                    phoneNumber: phone,
                    email,
                    firstName,
                    lastName,
                    countryCode: "966",
                }
                localStorage.setItem("tygo_user", JSON.stringify(user));
                if(res.status === 200) {
                    setState("otp");
                }
            }
            ).catch((err) => {
                setError(err.response.data.message);
            });
            
            }
            setLoading(false);
        }
        );
    }


    return (
        <div>
            <div className="page-container ">
                {/* <Header /> */}
                <div className="container h-100">
                <div className="card_form">
            <h1 className="my-4 d-none d-md-block">
                {t("store.register.title")}
            </h1>
            <h6 className=" d-block d-md-none">
                {t("store.register.title")}
            </h6>
            <div className="row payment_row my-3">
                <div className="col-md-12">
                    <div className="form-group">
                        <label htmlFor="">{t("store.register.firstname")}</label>
                        <input type="text" className="form-control" onChange={(e) => setFirstName(e.target.value)} />
                    </div>
                    <p className="text-danger">{firstNameError}</p>
                </div>
                <div className="col-md-12">
                    <div className="form-group">
                        <label htmlFor="">{t("store.register.lastname")}</label>
                        <input type="text" className="form-control" onChange={(e) => setLastName(e.target.value)} />
                    </div>
                    <p className="text-danger">{lastNameError}</p>
                </div>
                <div className="col-md-12">
                <div className="form-group">
                        <label htmlFor="">{t("store.register.email")}</label>
                        <input type="text" className="form-control" onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <p className="text-danger">{emailError}</p>
                </div>
                <div className="col-md-12">
                    <div className="form-group">
                        <label htmlFor="">{t("store.register.phone")}</label>
                        <input type="text" className="form-control" onChange={(e) => setPhone(e.target.value)} />
                    </div>
                    <p className="text-danger">{phoneError}</p>
                </div>
                                <div className="col-md-12">
                    <div className="form-group">
                        <label htmlFor="">{t("store.register.method")}</label>
                        <div className="row">
                            <div className="col-md-6">
                                <label className="check_box my-2 d-flex align-items-center">
                                    <input type="radio" name="radio" 
                                    onChange={(e) => {setMethod("Email")}}
                                    value="Email"
                                    checked={method === "Email"}
                                    />
                                    <span className="mx-3">{t("store.register.method1")}</span>
                                </label>
                            </div>
                            <div className="col-md-6">
                                <label className="check_box my-2 d-flex align-items-center">
                                    <input type="radio" name="radio" 
                                    onChange={(e) => {setMethod("PhoneNumber")}}
                                    value="PhoneNumber"
                                    checked={method === "PhoneNumber"}
                                    />
                                    <span className="mx-3">{t("store.register.method2")}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
                <p className="mb-2 pb-3 d-block">{t("store.register.info")}</p>
                            <p className="text-danger">{error}</p>
                            <Button inner={t("store.register.submit")}
                             color="primary mt-2" isfullWidth 
                                onClick={register}
                             isLoading={loading} />
               
                 
                </div>
                </div>
                <Modal show={state === "otp"} onHide={() => setState("register")} className="modal_store_info" style={
                {
                    direction: i18n?.language === "ar" ? "rtl" : "ltr"
                }
            }>
                <Modal.Header closeButton  style={{
                        border: "none",
                        padding: "0",
                        width: "100%"
                    }}>
                <Modal.Title>{t('store.otp.title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <OtpForm setState={setState} method={method} to={to} email={email} phoneNumber={phone} />
                </Modal.Body>
            </Modal>
            </div>
        </div>
    );
};

const Login = ({to} : {to: string | null}) => {
    const { t, i18n } = useTranslation();
    const [loading, setLoading] = useState<boolean>(false);
    const [emailMobile, setEmailMobile] = useState<string>("");
    const [error, setError] = useState<string>("");
    const [state, setState] = useState<string>("login");
    const [method, setMethod] = useState<string>("PhoneNumber");
    const login = async () => {
        setLoading(true);
        await loginAccount({
            email: emailMobile,
            phoneNumber: emailMobile,
            countryCode: "966",
            logintType: emailMobile.includes("@") ? "Email" : "PhoneNumber",
        }).then((res) => {
            if(res.status === 200) {
                setState("otp");
                //save user email
                // const user = JSON.parse(localStorage.getItem("tygo_user") || '{}');
                // user.email = emailMobile;
                // localStorage.setItem("tygo_user", JSON.stringify(user));
                setMethod(emailMobile.includes("@") ? "Email" : "PhoneNumber");
            }
            setLoading(false);
        }).catch((err) => {
            // alert(err.response.data.Message);
            setError(err.response.data.Message);
            setLoading(false);
        });
    }

    return (
        <div>
            <div className="page-container " >
                {/* <Header /> */}
                <div className="container">
                <div className="card_form">
                    <h1 className="text-center my-4 d-none d-md-block">
                        {t("login.title")}
                    </h1>
                    <h6 className="text-center d-block d-md-none">
                        {t("login.title")}
                    </h6>
                    <div className="payment_row my-3">
                            <div className="form-group">
                                <label className="text-start" htmlFor="">{t("login.mobile_email")}</label>
                                <input type="text" className="form-control" onChange={(e) => setEmailMobile(e.target.value)} />
                            </div>
                            
                        {/* <p className="mb-2 pb-3 d-block">{t("store.register.info")}</p> */}
                                    <p className="text-danger">{error}</p>
                                    <Button inner={t("login.login")} color="primary mt-2" isfullWidth  isLoading={loading} onClick={login} />
                                    {/* color="primary mt-2" isfullWidth  isLoading={loading} /> */}
                        
                        </div>
                </div>
                </div>
            </div>
             <Modal show={state === "otp"} onHide={() => setState("register")} className="modal_store_info" style={
                {
                    direction: i18n?.language === "ar" ? "rtl" : "ltr"
                }
            }>
                <Modal.Header closeButton  style={{
                        border: "none",
                        padding: "0",
                        width: "100%"
                    }}>
                <Modal.Title>{t('store.otp.title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <OtpForm setState={setState} method={method} to={to} email={emailMobile} phoneNumber={emailMobile} />
                </Modal.Body>
            </Modal>
        </div>
    );
};



export default Wrapper;
const OtpForm = ({setState, method, to, email, phoneNumber} : {setState: any, method: string, to: string | null, email: string, phoneNumber: string}) => {
    const {t, i18n} = useTranslation();
    const location = useLocation();
    const [error, setError] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [otp, setOtp] = useState(["", "", "", ""]);
    const inputRefs = useRef([...Array(4)].map(() => React.createRef())) as any;
    const user = JSON.parse(localStorage.getItem('tygo_user') || '{}');
    const navigate = useNavigate();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [counter, setCounter] = useState<number>(60);
    const handleOtpChange = (index: number, value: string) => {
      if (value === "") {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
  
        if (index > 0) {
          inputRefs.current[index - 1].current.focus();
        }
      } else if (+value >= 0 && +value <= 9) {
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);
  
        if (index < otp.length - 1) {
          inputRefs.current[index + 1].current.focus();
        }
      }
      if (index === otp.length - 1 && value !== "") {
        const otpValue = otp.join("");
        if (otpValue.length === 4) {
          verify(otpValue);
        }
      }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [otptype, setOtpType] = useState<string>("PhoneNumber");
    const handleKeyDown = (index: number, e: any) => {
      if (e.key === "Backspace" && index > 0 && otp[index] === "") {
        e.preventDefault();
        setOtp((prevOtp) => {
          const newOtp = [...prevOtp];
          newOtp[index - 1] = "";
          return newOtp;
        });
        inputRefs.current[index - 1].current.focus();
      }
    };
    const verify = async (str: string) => {
        if (!str || str.length !== 4) {
            setError(t("store.otp.invalid_code") || "Invalid code");
            return;
        }

        setLoading(true);
        try {
            const response = await verifyCode(str, method, email, phoneNumber, "966");
            
            if (response?.data) {
                const user = JSON.parse(localStorage.getItem("tygo_user") || "{}");
                user.token = response.data.token;
                user.userId = response.data.userId;
                user.tokenExpiryDate = response.data.tokenExpiryDate;
                localStorage.setItem("tygo_user", JSON.stringify(user));
                // If to already has query params, append the additional ones
                if (to && to.includes('?')) {
                    const [basePath, existingParams] = to.split('?');
                    const existingParamsObj = new URLSearchParams(existingParams);
                    const newParams = new URLSearchParams(location.search);
                    // 'redirect' says where to go, it is not a param of the
                    // destination — carrying it over pollutes the target URL.
                    newParams.delete('redirect');
                    
                    // Add all existing params that aren't already in the URL
                    newParams.forEach((value, key) => {
                        if (!existingParamsObj.has(key)) {
                            existingParamsObj.append(key, value);
                        }
                    });
                    
                    navigate(`${basePath}?${existingParamsObj.toString()}`);
                } else {
                    // If there are query params in the current URL, append them to the redirect
                    const currentParams = new URLSearchParams(location.search);
                    currentParams.delete('redirect');
                    // Separator is determined by whether the URL already has a query string
                    const separator = to && to.includes('?') ? '&' : '?';
                    const fullPath = to || '/';
                    const queryString = currentParams.toString();
                    
                    navigate(queryString ? 
                        `${fullPath}${fullPath.includes('?') ? '&' : '?'}${queryString}` : 
                        fullPath);
                }
            } else {
                setError(t("store.otp.invalid_response") || "Invalid response");
            }
        } catch (err: any) {
            console.error("Verification error:", err);
            setError(t("store.otp.error") || "An error occurred");
        } finally {
            setLoading(false);
        }
    }
    // Email
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const Resend = async (typw:string) => {
        // const user = JSON.parse(localStorage.getItem("tygo_user")!);
        // createAccount({
        //     firstName:user.name.split(" ")[0],
        //     gander:"Male",
        //     countryCode: "966",
        //     email:user.email,
        //     phoneNumber:user.phoneNumber.toString().replace(/^0+/, ''),
        //     registertionType: typw,
        // })
        loginAccount({
          
                    email:user.email,
                    phoneNumber:user.phoneNumber.toString().replace(/^0+/, ''),
                    countryCode: "966",
                    logintType: typw,}).then(e=>{
                        toast.success(t("store.otp.message"));
                    })
                
        
        .then(e=>{
            toast.success(t("store.otp.message"));
        })
        .catch(
            (err) => {
                // loginAccount({
                //     email:user.email,
                //     phoneNumber:user.phoneNumber.toString().replace(/^0+/, ''),
                //     countryCode: "966",
                //     logintType: typw,}).then(e=>{
                //         toast.success(t("Otp Has been sent"));
                //     })
                // })
                // .catch((err) => {
                    setError(err.response.data.message);
                }
            );

    }

    useEffect(() => {
        const interval = setInterval(() => {
            setCounter((prev) => {
                if(prev === 0) {
                    clearInterval(interval);
                    return 60;
                }
                return prev - 1;
            });
        }, 1000);
        return () => clearInterval(interval);
    }, []);


    return (
        <div className="card_form">
            <div className="form-group">
            
            <p>{t("store.otp.info")} {method === "PhoneNumber" ? user.phoneNumber : user.email}</p>
                <div className="my-3 otp_inputs">
                {otp.map((digit, index) => (
        <input
        //   autoFocus={index === 0 ? true : undefined}
        autoFocus={index === 0 ? true : undefined}
          key={index}
          type="number"
          className="form-control"
          maxLength={1}
          value={digit}
          ref={inputRefs.current[index]}
          onKeyDown={(e) => handleKeyDown(index, e)}
          onChange={(e) => handleOtpChange(index, e.target.value)}
        />
      ))}
            
                </div>
            </div>
            <p className="text-danger">{error}</p>
            <div className="row my-4">
                {/* <div className="col-md-6">
                    <Button inner={
                        (counter !== 60 ? counter.toString()+ " "+ t("store.otp.s_to")
                        : "")+ " "+ t("store.otp.resend")}
                         color="secondary" isfullWidth isDisabled={counter!==60}
                     onClick={()=>{
                        Resend("PhoneNumber");
                        const interval = setInterval(() => {
                            setCounter((prev) => {
                                if(prev === 0) {
                                    clearInterval(interval);
                                    return 60;
                                }
                                return prev - 1;
                            });
                        }, 1000);
                        return () => clearInterval(interval);
                        }}
                        />
                </div>
                <div className="col-md-6">
                    <Button inner={t("store.otp.to_email")}
                     color="secondary" isfullWidth onClick={()=>{
                        setOtpType("Email");
                        Resend("Email");
                    }} />
                </div> */}
            </div>
            <Button inner={t("store.otp.submit")}
             color="primary" isfullWidth onClick={
                () => {
                    const otpValue = otp.join("");
                    verify(otpValue);
                }
             }
             isLoading={loading} />
        </div>
    );

}